import gql from 'graphql-tag'

import AutomationHandler from './AutomationHandler'
import list from './gql/listAutomationTaskServer'
import updateServerTask from './gql/updateAutomationTaskServer'
import createServerTask from './gql/createAutomationTaskServer'
import deleteServerTask from './gql/deleteAutomationTaskServer.js'
import { listCols } from './tableColumns'
import { ServerTask } from './pages'

const conf = t => ({
	link: 'automation',
	baseUrl: '',
	typename: 'AutomationTaskServer',
	subsections: [{
		link: 'server',
		exact: true,
		component: ServerTask,
		updateMutation: updateServerTask,
		subsectionQuery: gql`query{_}`
	}],
	addNewRecord: true,
	listQuery: list,
	createMutation: createServerTask,
	deleteMutation: deleteServerTask,
	columns: listCols(t),
	handler: AutomationHandler
})

export default conf
